import { render, staticRenderFns } from "./terra-list-header.vue?vue&type=template&id=2c357312&scoped=true"
import script from "./terra-list-header.vue?vue&type=script&lang=js"
export * from "./terra-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c357312",
  null
  
)

export default component.exports